enum Currencies{
  CAD = "CAD",
  USD = "USD",
  AUD = "AUD",
}

export default Currencies
